import * as React from "react"
import { useState, useEffect } from "react"
import { useLocation } from "@reach/router";
import { useUserObjectState, useAuthState } from "@myaccountServices"
import { doRedirect } from "../../utils"
import axios from "axios";
import { apiUrl, getToken } from '../../services/store/utils'

/**
 * Auth
 */

const baseURL = apiUrl()
const token = getToken()

// With header call
const authInstance = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

const createUserobject = (params) => {
  return authInstance.post("/stb-users/userobjects", params);
};


const SaveProperty = props => {
    const { state, services } = useUserObjectState()
    const { state: authState, services: authServices } = useAuthState()
    const isAuthenticated = authServices.isAuthenticated()
    const location = useLocation();
    const [savedResponse, setSavedResponse] = useState(props.userObjects)

    useEffect( () => {
        setSavedResponse(props.userObjects);
    }, [props.userObjects])

    const handleSaveProperty = (params, status, type) => {
        let saveparams = {
            params: params,
            type: type,
            state: status,
        }

        if (!isAuthenticated) {
            // save params to send auth params
            authServices.storeData('auth_params', saveparams);
            authServices.storeData('auth_return', location.href);
            doRedirect(process.env.GATSBY_MYACCOUNT_URL);
        } else {
            createUserobject(saveparams).then(
                (userObjectsData) => {
                    setSavedResponse(userObjectsData.data.data);
                }
              );
        }
    }

    const isSaved = (params, type) => {
        if (!isAuthenticated) return false

        if (savedResponse)
            return services.isSaved(savedResponse, params, type)
    }

    let params = props.searchParams ? props.searchParams : {id: props.pid};
    let isSavedItem

    if (savedResponse) {
        isSavedItem = isSaved(params, props.type)
    }

    let savedClass = "wishlist-icn",
        title = "Save ";
    if(isSavedItem) {
        savedClass = "wishlist-icn saved"
        title = "Saved "
    }

    return (
        <>
            <div className={savedClass} aria-label={title + props.type} title={title + props.type}
                onClick={() => {
                    handleSaveProperty(params, !isSavedItem, props.type)
                }}
            >
                <i className="icon-heart"></i>
            </div>
        </>
    )
}

export default SaveProperty
